import React from "react";
import styled from "styled-components";

const ToLogin: React.FC = () => {
  return (
    <Page>
      <LoginLink href="/l-in">Uloguj se</LoginLink>
    </Page>
  );
};

export default ToLogin;

const Page = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoginLink = styled.a`
  font-size: 1.1rem;
  font-weight: 500;
  text-decoration: none;

  color: #2c6bed; /* sekundarna boja */
  padding: 0.5rem 1.5rem;

  border: 1px solid #2c6bed;
  border-radius: 4px;

  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: #2c6bed;
    color: #ffffff;
  }
`;
